import { action, observable } from 'mobx';
import Project from '../entity/Project';

class ProjectStore {
  public static generateFromApiResponse(responses: any[]): Project[] {
    const projects: Project[] = [];
    responses.forEach(project => {
      projects.push(new Project(project));
    });
    projects.sort(this.compare);
    return projects;
  }

  private static compare(a: Project, b: Project) {
    if (a.state < b.state) return -1;
    if (a.state > b.state) return 1;
    if (a.elapsedDays < b.elapsedDays) return -1;
    if (a.elapsedDays > b.elapsedDays) return 1;
    if (a.id < b.id) return -1;
    if (a.id > b.id) return 1;
    return 0;
  }

  @observable public projects: Project[];
  @observable public isLoading: boolean = true;

  @action
  public setOrganizationProject(responses: any): void {
    this.projects = ProjectStore.generateFromApiResponse(responses);
  }

  @action
  public setLoading(isLoading: boolean): void {
    this.isLoading = isLoading;
  }
}

export default ProjectStore;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/domain/store/ProjectStore.ts